import React from "react";
import { useTranslation } from "react-i18next";
import Styles from "./TrustBanner.module.scss";

import weltLogo from "../../assets/img_used/welt.svg";
import sat1Logo from "../../assets/img_used/sat1.svg";
import focusOnlineLogo from "../../assets/img_used/focusOnline.svg";
import bildLogo from "../../assets/img_used/bild.svg";
import chipLogo from "../../assets/img_used/chip.svg";
import classNames from "classnames";

const logos = [
  { src: weltLogo, alt: "Die Welt" },
  { src: sat1Logo, alt: "Sat1" },
  { src: focusOnlineLogo, alt: "Focus Online" },
  { src: bildLogo, alt: "Bild" },
  { src: chipLogo, alt: "Chip" },
];

type Props = {
  noTitle?: boolean;
  className?: string;
};

const TrustBanner = ({ noTitle = false, className }: Props) => {
  const { t } = useTranslation();
  return (
    <div className={classNames(Styles.trustBannerTopContainer, className)}>
      {!noTitle && <div className={Styles.trustBannerKnownFrom}>{t("knownFrom")}</div>}
      <div className={Styles.trustBannerFlexContainer}>
        {logos.map((logo, i) => (
          <div className={Styles.trustBannerFlexItem} key={"trb_" + i}>
            <img src={logo.src} className={Styles.trustBannerLogoItem} alt={logo.alt} />
          </div>
        ))}
      </div>
    </div>
  );
};

export default TrustBanner;
